import React from "react";
import { HelpCircle } from "lucide-react";

// Shared operator-facing guidance for equipment-lease pricing fields. The
// backend stores minor currency units and basis points; every consumer must
// present normal dollars/percentages, so the copy lives in one place.
export const leaseFieldHelpText = {
  purchaseCostAmount:
    "Internal accounting-only equipment cost basis. This value is used for internal reporting and does not affect the customer's lease price. Enter the normal currency amount, such as $399.00.",
  purchaseCostCurrency:
    "Internal accounting-only currency for the equipment cost basis. This should match the selling market currency, usually USD.",
  intendedSalePriceAmount:
    "The customer-facing price used as the basis for all lease payment calculations. Enter the normal currency amount, such as $499.00.",
  intendedSalePriceCurrency:
    "Customer-facing currency that drives lease payment calculations. This should match the selling market currency, usually USD.",
  leaseRateBps:
    "Recurring annual interest rate. Enter the normal percentage, such as 8.25%. This one rate applies across all allowed term options on the offer.",
  allowedTermMonths:
    "Comma-separated list of customer-selectable lease terms in months. Example: 24, 36, 48. The customer picks one of these term lengths later.",
  minimumUpfrontPaymentAmount:
    "Lowest upfront payment the customer is allowed to choose. Enter the normal currency amount, or 0 to allow no upfront payment.",
  maximumUpfrontPaymentAmount:
    "Highest upfront payment the customer is allowed to choose. Enter the normal currency amount. This cannot exceed the equipment's intended sale price.",
};

export function FieldHelpTooltip({ label, text }: { label: string; text: string }) {
  return (
    <span className="group/field-tooltip relative inline-flex">
      <button
        type="button"
        aria-label={`${label} help`}
        className="inline-flex h-4 w-4 items-center justify-center rounded-full text-muted-foreground/70 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
      >
        <HelpCircle className="h-3.5 w-3.5" />
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-0 top-full z-30 mt-2 hidden w-64 rounded-md border border-border/60 bg-background px-3 py-2 text-[11px] font-medium normal-case tracking-normal text-foreground shadow-lg group-hover/field-tooltip:block group-focus-within/field-tooltip:block"
      >
        {text}
      </span>
    </span>
  );
}
